import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import { UtilsService } from 'src/app/shared/utils.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ChangeImageComponent } from 'src/app/shared/change-image/change-image.component';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  profileForm!: FormGroup;
  userID: number;
  usedCount = 0;
  userData: User;
  srcResult: any;
  newImage: any;
  subscriptionType = '';

  constructor(public dialog: MatDialog, private dataService: DataService,
              private authService: AuthService,
              public utils: UtilsService
              ) {
                this.newImage = null;
                this.userData = this.authService.getUserData();
                this.userID = this.userData.id;
                if (this.userData.picturePath === undefined)  {
                  this.userData.picturePath = '../../../assets/images/avatar.png';
                }
              }

  ngOnInit(): void {
    this.utils.setTitle('Profile');
    this.utils.screenTitle.emit({firstTitle: 'Profile', firstRoute: '/profile'});
    this.dataService.get('user/RetrieveUser/' + this.userID).then((data: any) => {
      if (data.statusCode === 200) {
        const existingUser = this.authService.getUserData();
        const mergedUser = {
          ...existingUser,
          ...data.data
        };

        this.authService.setUserData(mergedUser);
        this.utils.saveUserData(mergedUser);
        this.userData = mergedUser;

        if (data.data.promotionCodeCount > 199) {
          this.subscriptionType = "Titanium";
        } else if (data.data.promotionCodeCount > 99) {
          this.subscriptionType = "Diamond";
        } else if (data.data.promotionCodeCount > 49) {
          this.subscriptionType = "Platinum";
        } else if (data.data.promotionCodeCount > 19) {
          this.subscriptionType = "Gold";
        } else if (data.data.promotionCodeCount > 9) {
          this.subscriptionType = "Silver";
        } else if (data.data.promotionCodeCount > 4) {
          this.subscriptionType = "Bronze";
        }
        else{
          this.subscriptionType = "Lite / Trial Sign up ";
          if(data.data.type == 3){
            this.subscriptionType = "Trial Sign Up ";
          }
        }
        this.userData = this.authService.getUserData();
        this.profileForm = new FormGroup({
          first_name: new FormControl(this.userData.firstName, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          last_name: new FormControl(this.userData.lastName, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          title: new FormControl(this.userData.title, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          email: new FormControl(this.userData.email,[Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
          country_code: new FormControl(this.userData.countryCode, [Validators.required, Validators.maxLength(5)]),
          phone_number: new FormControl(this.userData.phone, [Validators.required, Validators.minLength(7), Validators.maxLength(14)]),
        });
      }
    });
    this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/'+this.authService.getUserData().id+'?pageNumber=1&pageSize=1&searchKeyword=&isUsed=true').then((data: any) => {
      if (data.statusCode === 200) {
          this.usedCount = data.data.count;
      }
    });
    this.profileForm = new FormGroup({
      first_name: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      last_name: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      title: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
      country_code: new FormControl(null, [Validators.required, Validators.maxLength(5)]),
      phone_number: new FormControl(null, [Validators.required, Validators.minLength(7), Validators.maxLength(14)]),
    });
  }

  openChangePassword() {
      const dialogRef = this.dialog.open(ChangePasswordComponent, {disableClose: true, width: '500px'});
      dialogRef.afterClosed().subscribe((status) => {
      });
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  editProfileImage() {
    this.dialog.open(ChangeImageComponent, {
      disableClose: true,
      width: '500px',
      data: {dialogParent: this, existingImage: this.userData && this.newImage ? this.newImage : this.userData.picturePath, title:  this.userData && this.userData.picturePath ? null : 'Add New Image', resizeImage: true, aspectRatio: true}
    }).afterClosed().subscribe(result => {
      if (result) {
        this.newImage = result.croppedImage64;
      }
    });
  }

  updateUserData() {
    this.dataService.get('user/RetrieveUser/' + this.userID).then((data: any) => {
      if (data.statusCode === 200) {
        const existingUser = this.authService.getUserData();
        const mergedUser = {
          ...existingUser,
          ...data.data
        };

        this.authService.setUserData(mergedUser);
        this.utils.saveUserData(mergedUser);
        this.userData = mergedUser;
        this.authService.userDataChanged.emit(this.userData);
      }
    });
  }

  onSubmit() {
    if (this.profileForm.valid) {
      const payload = {
        FirstName: this.profileForm.get('first_name')?.value,
        LastName: this.profileForm.get('last_name')?.value,
        Title: this.profileForm.get('title')?.value,
        Email: this.profileForm.get('email')?.value,
        Phone: (this.profileForm.get('phone_number')?.value || '').replace(/\s+/g, ''),
        CountryCode: this.profileForm.get('country_code')?.value,
        UserId: parseInt(this.userID.toString(), 10),
        DateOfBirth: this.userData.dateOfBirth,
        Image: this.newImage !== null ? this.newImage.slice(22, this.newImage.length) : null
      };

      this.dataService.put('user/UpdateUser', payload).then((data) => {
        if (data.statusCode === 200) {
          this.updateUserData();
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Profile information updated successfully',
              buttonText: 'Ok'
            }
          });
        } else if (data.statusCode === 613) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Invalid phone format!',
              buttonText: 'Ok'
            }
          });
        }else if (data.statusCode === 624) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: data.message + '!',
              buttonText: 'Ok'
            }
          });
        }
         else {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.profileForm.markAllAsTouched();
    }
  }
}
